import { FormControlLabel } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import {
  CheckboxSmall,
  CustomMultiFormControl,
  FieldSetStyles,
} from "../../styles";
import { SourceType } from "@authory-packages/core";

type SourceQuickSettingsConfProps = {
  active: boolean;
  onActiveChange: () => void;
  pastContent: boolean;
  useProxy: boolean;
  onUseProxyChange: () => void;
  useShiva: boolean;
  onUseShivaChange: () => void;
  useLLM: boolean;
  onUseLLMChange: () => void;
  disabled: boolean;
  sourceType: SourceType;
};

export const SourceQuickSettingsConf = ({
  active,
  onActiveChange,
  pastContent,
  useProxy,
  onUseProxyChange,
  useShiva,
  onUseShivaChange,
  disabled,
  useLLM,
  onUseLLMChange,
  sourceType,
}: SourceQuickSettingsConfProps) => {
  const fieldSetStyles = FieldSetStyles();

  const customMultiFormControl = CustomMultiFormControl();

  return (
    <fieldset className={fieldSetStyles.container} style={{ paddingBottom: 6 }}>
      <legend>Quick Settings:</legend>
      <FormControlLabel
        className={customMultiFormControl.root}
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="active"
            checked={active}
            onChange={onActiveChange}
            size="small"
          />
        }
        label="Active"
      />
      <FormControlLabel
        className={customMultiFormControl.root}
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="pastContent"
            checked={pastContent}
            disabled
            size="small"
          />
        }
        label="Past Content"
      />
      <FormControlLabel
        className={customMultiFormControl.root}
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="useProxy"
            disabled={disabled}
            checked={useProxy}
            onChange={onUseProxyChange}
            size="small"
          />
        }
        label="CC/FC Proxy"
      />
      <FormControlLabel
        className={customMultiFormControl.root}
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="useShiva"
            checked={useShiva}
            onChange={onUseShivaChange}
            size="small"
          />
        }
        label="Custom Extraction only"
      />
      <FormControlLabel
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="useLLM"
            checked={useLLM}
            onChange={onUseLLMChange}
          />
        }
        label="LLM"
      />
    </fieldset>
  );
};
